import { MainKeys } from '../../../main/main.key';
import { Places } from '../../../route-consts';
/**
 * A recuperacao de senha.
 *
 * Herda de `MainKeys`, e nao de `RestrictedKeys`: quem esqueceu a senha nao tem
 * sessao, entao a tela fica fora do HUB.
 *
 * Sem parametro algum, e de proposito. A etapa em que o fluxo esta DEPENDE do
 * e-mail digitado e do token recebido, e nenhum dos dois pode ir para o endereco -
 * um link para a etapa 3 nao teria como ser honrado, e o codigo expira em tres
 * minutos de qualquer forma. Publicar uma etapa que nao se pode restaurar seria
 * uma promessa que o reload quebra.
 */
export class ForgotPasswordKeys extends MainKeys {
    get place() {
        return Places.forgotPassword;
    }
}
//# sourceMappingURL=forgot-password.key.js.map